var _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3337 17.8004C23.3337 13.1372 20.3043 9.22573 16.2225 8.1665M4.66699 17.8004C4.66699 13.1372 7.69635 9.22573 11.7782 8.1665",
    stroke: "#878C91",
    strokeWidth: 2.33333
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 17.5,
    width: 21,
    height: 4.66667,
    rx: 1.16667,
    stroke: "#878C91",
    strokeWidth: 2.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6905 5.83325C16.3577 5.83325 16.8891 6.3918 16.8557 7.05818L16.3337 17.4999L11.667 17.4999L11.1449 7.05818C11.1116 6.3918 11.6429 5.83325 12.3101 5.83325L15.6905 5.83325Z",
    stroke: "#878C91",
    strokeWidth: 2.33333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.6b694b730c4a44c4e7f6593610519560.svg";
export { ForwardRef as ReactComponent };